import { useEffect } from 'react';
import { getUserContext } from '@cbhq/client-analytics';

import useLocalStorage from ':cloud/hooks/useLocalStorage';
import { logMetric } from ':cloud/init/clientAnalytics/metricsLogging';

/**
 * Records the current user session UUID & emits
 */
function useSetSessionUUID() {
  const [sessionUUID, setSessionUUID] = useLocalStorage<string>('sessionUUID', '');

  useEffect(() => {
    const currentSessionUUID = getUserContext().sessionUUID;
    if (currentSessionUUID && currentSessionUUID !== sessionUUID) {
      logMetric('session');
      setSessionUUID(currentSessionUUID || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setSessionUUID, getUserContext().sessionUUID]);

  return sessionUUID;
}

/**
 * Records first full-page error occur for the current session UUID
 */
function useSetErrorSessionUUID() {
  const sessionUUID = useSetSessionUUID();
  const [errorSessionUUID, setErrorSessionUUID] = useLocalStorage<string>('errorSessionUUID', '');

  useEffect(() => {
    // Mark the first time a user hits a full-page error screen in a given session
    if (sessionUUID && sessionUUID !== errorSessionUUID) {
      logMetric('full_page_error');
      setErrorSessionUUID(sessionUUID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionUUID, setErrorSessionUUID]);

  return errorSessionUUID;
}

export { useSetErrorSessionUUID, useSetSessionUUID };
